import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import { useEffect, useCallback, useRef } from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import { useParams, useNavigate } from "react-router-dom";

import "./saveSignature.css";
import { useLoading } from "components/UI/LoadingSpinner/UseLoading";
import { useAuth } from "hooks/useAuth";
import { getCurrentDate } from "utils/timeUtils";

const SaveSignature = () => {
  const { packageType, signature_id, signer } = useParams();
  const navigate = useNavigate();
  const dataFetchedRef = useRef(false);
  const { authToken, csrfToken } = useAuth();
  const { showLoadingSpinner, hideLoadingSpinner } = useLoading();

  const saveSignature = useCallback(() => {
    axios
      .post(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/save_signature/`,
        {
          product_id: signature_id,
          packageType: packageType,
          signer: signer,
          uploaded_on: getCurrentDate(),
        },
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then(() => {
        hideLoadingSpinner();
        if (signer !== "Vendor") {
          navigate(`/community/products/details/${signature_id}`);
        } else {
          navigate(`/community`);
        }
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }, []);

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    showLoadingSpinner("Redirecting");
    saveSignature();
  }, []);

  return (
    <Container>
      <Card className="login-card success">
        <Card.Body>
          <CheckBoxIcon color="primary" sx={{ fontSize: 100 }} />
          <Card.Title as="h4">Success</Card.Title>
          <p className="small">You are being redirected...</p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SaveSignature;
